import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-cust-grp-menu',
  templateUrl: './cust-grp-menu.component.html',
  styleUrls: ['./cust-grp-menu.component.css']
})
export class CustGrpMenuComponent implements OnInit {
    custGrpId;

    public menu?: Menu;

    public customerGroupNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'custgrplangs', gotoParms: () => this.menu!.custgrp_id ?? '' }
    ];

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.custGrpId = this.stateService.getStateParams()['custgrp_id'];
    }

    private async loadMenu() {
        if (!!this.custGrpId) {
            this.menu = (await this.datatask.Post(1006, { custgrp_id: this.custGrpId }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(1011, this.menu);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    custgrp_id: string;
    custgrp_name: string;
    discgrpcust_name: string;
}
